import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";
import { Eyebrow, MaskLines, ClipImage, EASE } from "./Motion";

const ITEMS = [
  { y: "1981", t: "Pepe Ireland Ltd", d: "Set up by Sunil & Jay Shah, launching distribution of Pepe Jeans in Ireland & Northern Ireland." },
  { y: "1984", t: "Made in Naas", d: "Due to high demand, local manufacturing opens in Naas, Co. Kildare — eventually serving international markets too." },
  { y: "1986", t: "Pepe Shoes", d: "Licence acquired to design & distribute Pepe Shoes in Ireland, followed by export to international markets." },
  { y: "1998", t: "Tommy Hilfiger Ireland", d: "Agency acquired across wholesale, retail concept & outlet, concessions, franchise and shop-in-shop — in leading multi-brand retailers across 32 counties." },
  { y: "2005", t: "Jaisun House opens", d: "A purpose-built HQ and showrooms in Dundrum. The same year, Pepe Jeans Retail opens its first store in Dundrum Town Centre." },
  { y: "2013", t: "A new chapter", d: "After 32 years, we exit Pepe Jeans to diversify into alternative global lifestyle brands — carrying decades of brand-building experience." },
  { y: "Today", t: "Nine international brands", d: "Guess apparel, accessories & footwear, Tiffosi, JOOP!, Happy Socks, Heskimo, Camper, G-Star and Fantasy Sandals." },
];

const Item = ({ it, i, onActive }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "-45% 0px -45% 0px" });
  useEffect(() => {
    if (inView) onActive(i);
  }, [inView, i, onActive]);
  return (
    <motion.li ref={ref} data-testid={`timeline-item-${it.y}`} className="grid grid-cols-[72px_1fr] gap-6 border-t border-white/10 py-10 sm:grid-cols-[110px_1fr]" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease: EASE }}>
      <span className="font-mono text-sm text-[#c8a97e]">{it.y}</span>
      <div>
        <h3 className="font-display text-3xl sm:text-4xl">{it.t}</h3>
        <p className="mt-4 max-w-lg text-base leading-relaxed text-[#c9c6c0]">{it.d}</p>
      </div>
    </motion.li>
  );
};

export const Heritage = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="story" data-testid="story-section" className="relative border-t border-white/10 bg-[#121418]">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-16 px-6 py-24 sm:px-10 sm:py-32 lg:grid-cols-12 lg:px-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Eyebrow index="03">Story So Far</Eyebrow>
            <h2 className="mt-8 font-display text-6xl leading-[0.9] sm:text-7xl">
              <MaskLines inView lines={["Forty-five", <em key="y" className="text-[#c8a97e]">years, one</em>, "journey."]} />
            </h2>
            <div className="relative mt-12 hidden h-[150px] overflow-hidden lg:block">
              <AnimatePresence initial={false}>
                <motion.div key={active} data-testid="timeline-active-year" className="absolute inset-0 font-display text-[150px] leading-none text-[#f5f3ef]/90" initial={{ y: "100%" }} animate={{ y: "0%" }} exit={{ y: "-100%" }} transition={{ duration: 0.8, ease: EASE }}>
                  {ITEMS[active].y}
                </motion.div>
              </AnimatePresence>
            </div>
            <ClipImage src="/assets/SSF5.jpg" alt="Jaisun House showrooms" className="mt-10 aspect-[16/9] w-full" />
          </div>
        </div>
        <ol className="lg:col-span-6 lg:col-start-7">
          {ITEMS.map((it, i) => <Item key={it.y} it={it} i={i} onActive={setActive} />)}
        </ol>
      </div>
    </section>
  );
};
